<template>
  <details class="control-settings academy-control" @toggle="onToggle">
    <summary>Fristen und Benachrichtigungen</summary>
    <v-progress-linear v-if="loading" indeterminate color="#58d388" class="mt-4" />
    <div v-if="form">
      <div class="control-fields">
        <v-switch v-model="form[area].push" dark inset color="#58d388" label="Push und App-Benachrichtigungen" :disabled="saving" />
        <v-switch v-model="form[area].email" dark inset color="#58d388" label="E-Mail-Benachrichtigungen" :disabled="saving" />
      </div>
      <p class="control-note">Neue Audit-Protokolle werden der Leadership-Kontaktperson gemeldet, ersatzweise der Leadership-Verwaltung. Interne Bewertungen werden nicht an Mitarbeitende versendet.</p>
      <p class="control-note mt-2">Beide Kanäle sind unabhängig. Ausgeschaltete Kanäle versenden nichts; alte Nachrichten werden später nicht nachgeholt. Versandprüfung alle 15 Minuten.</p>
      <div class="control-actions"><v-btn color="#58d388" class="black--text" :loading="saving" :disabled="loading" @click="save">Einstellungen speichern</v-btn><span v-if="saved" class="control-note">Gespeichert</span></div>
    </div>
    <v-alert v-if="error" type="error" text class="mt-3">{{ error }}<v-btn v-if="!saving" text @click="load">Neu laden</v-btn></v-alert>
  </details>
</template>
<script>
import api from "@/api"
export default {
  props: { area: { type: String, required: true } },
  data: () => ({ form: null, loading: false, saving: false, error: "", saved: false }),
  methods: {
    onToggle(event) { if (event.target.open && !this.form && !this.loading) this.load() },
    async load() {
      this.loading = true; this.error = ""
      try { this.form = await api.academyControl.settings() } catch (error) { this.error = "Einstellungen konnten nicht geladen werden." }
      finally { this.loading = false }
    },
    async save() {
      if (this.saving) return
      this.saving = true; this.error = ""; this.saved = false
      try {
        this.form = await api.academyControl.saveSettings({ audits: this.form.audits, revision: this.form.revision, area: this.area })
        this.saved = true; this.$emit("saved")
      } catch (error) { this.error = (error.response && error.response.data.error) || error.message || "Speichern fehlgeschlagen." }
      finally { this.saving = false }
    },
  },
}
</script>
<style scoped src="./control.css"></style>
